import { Button, Dialog, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import { useMutation } from "react-query";
import {
  generatePropertyShareLink,
  setLeadContactPermissions,
} from "../../api/api";
import ShareIcon from "@mui/icons-material/Share";
import { DialogHeader } from "../../components/dialogs/DialogHeader";
import { useProperty } from "../../hooks/property.hooks";
import { PropertyNewLinkShareSettings } from "./PropertyNewLinkShareSettings";
import { useTranslation } from "react-i18next";
import { useOrganization } from "../../hooks/organization.hooks";

interface PropertyShareButtonProps {
  propertyId: string;
}

export const PropertyShareButton: React.FC<PropertyShareButtonProps> = ({
  propertyId,
}) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  const handleClose = () => {
    setOpen(false);
  };

  const { data: property } = useProperty(propertyId);
  const { data: organization } = useOrganization();
  if (!property || !organization) {
    return null;
  }

  return (
    <>
      <Button
        variant="outlined"
        onClick={async () => {
          setOpen(true);
        }}
        style={{ alignSelf: "flex-end" }}
        startIcon={<ShareIcon />}
      >
        {t("propertyShare.share")}
      </Button>
      <Dialog open={open} onClose={handleClose} scroll="body">
        <DialogHeader title={t("propertyShare.share")} onClose={handleClose} />
        <PropertyNewLinkShareSettings
          propertyId={property._id}
          organization={organization}
        />
      </Dialog>
    </>
  );
};
